import { useMemo } from 'react'
import {
  useListClientTags
} from '../../../../../api/dataMaintenance'

export const useTags = () => {
  const { data, error, isLoading, isError } = useListClientTags()
  const tagData = useMemo(() => {
    if (data && data.response.ok) {
      return data.data
    }
    return null
  }, [data])

  const tagDetails = useMemo(() => {
    if (tagData && tagData.listData) {
      return tagData.listData
    }
    return null
  }, [tagData])
  return { tagData, isLoading, isError, error, tagDetails }
}
